<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      title="打印标签"
      class="materialCodeModal"
      width="800px"
      :append-to-body="true">
    <div id="content" :loading="contentLoading">
      <div v-for="(item,index) in TagInfo" id="printMaterialCode" :key="index">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td rowspan="3">
              <div :id="'qrCode'+item.serialNo" align="center"/>
            </td>
            <td colspan="2">{{item.serialNo}}</td>
          </tr>
          <tr>
            <td>{{item.billNO}}</td>
            <td v-if="item.serialNoType ===10 && item.minPackageQuantity === 0 ">{{1}}kg</td>
            <td v-else-if="item.serialNoType === 10">{{item.minPackageQuantity}}kg</td>
            <td v-else-if="item.serialNoType === 20">{{item.boxQuantity}}kg</td>
          </tr>
          <tr>
            <td colspan="2">{{item.materialName ? item.materialName.substring(0,20) : ''}}</td>
          </tr>
          <tr>
            <td colspan="3">规格:{{item.specification}}</td>
          </tr>
          <tr>
            <td colspan="3">{{item.note}}</td>
          </tr>
        </table>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        TagInfo: [
          {
            materialNo: "",
            receiptQuantity: "",
            serialNo: "",
          },
        ],
      };
    },

    methods: {
      open(info) {
        this.dialogVisible = true;
        this.TagInfo = info;
        for (let item of this.TagInfo) {
          this.$nextTick(() => {
            document.getElementById("qrCode" + item.serialNo).innerHTML = "";
            this.bindQRCode(item.serialNo);
          });
        }
      },
      bindQRCode(serialNo) {
        let text = serialNo;
        new QRCode(document.getElementById("qrCode" + serialNo), {
          text: text,
          width: 80,
          height: 80,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },
      print() {
        document.body.innerHTML = document.getElementById("content").parentNode.innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
    },
  };
</script>

<style lang="scss" scoped>
.materialCodeModal .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.materialCodeModal .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.materialCodeModal .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.materialCodeModal .el-divider--horizontal {
  margin: 10px 0;
}

.materialCodeModal .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>

<style lang="scss" scoped>
#content {
  width: 76mm;
  height: 36mm;
  margin: 0 auto;
  margin-top: 1.5mm;
  page-break-before: always;
  font-size: 10px;
  table {
    width: 100%;
    height: 100%;
    td {
      border: 1px solid #111;
      border-bottom: 0;
      border-right: 0;
      padding: 1mm;
      box-sizing: border-box;
      // height: 7mm;
    }
    tr:last-child td {
      border-bottom: 1px solid #111;
    }
    tr td:last-child {
      border-right: 1px solid #111;
    }
  }
}
</style>